export default "__VITE_ASSET__0978969f__"